import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss',
})
export class ComingSoonComponent implements OnInit {
  /**
   * When true (default), renders with public header & footer.
   * When false, only renders the inner content block (for embedding inside admin layout).
   */
  @Input() standaloneLayout: boolean = true;

  pageTitle = 'Page Coming Soon';
  pageMessage = `We're working on something amazing. This page will be available shortly.`;

  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    const data = this.route.snapshot.data;
    const title = data['comingSoonTitle'] as string | undefined;
    const message = data['comingSoonMessage'] as string | undefined;
    if (title?.trim()) {
      this.pageTitle = title.trim();
    }
    if (message?.trim()) {
      this.pageMessage = message.trim();
    }
  }
}
